import React, { useState, useEffect } from "react";
import axios from "axios";

import { ProcedureJoinManagement } from "@components/Procedure";
import { procedureJoinKeys } from "@components/Procedure/ProcedureJoinManagement";
import { Button } from "@components/shared";
import { PostOpForm } from "./";
import { varietyOptions } from "./postOpOptions";

const STEP_POSTOP = "postop";
const STEP_COMPLICATIONS = "complications";

export default function PostOpCreate({
  procedureDate,
  procedureId,
  onSuccess,
  eye,
}) {
  const [activeStep, setActiveStep] = useState(STEP_POSTOP);
  const [postOpId, setPostOpId] = useState(null);
  const [postOp, setPostOp] = useState(null);
  const [existingVisits, setExistingVisits] = useState([]);
  const [visitVariety, setVisitVariety] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(() => {
    axios
      .get(`/procedures/${procedureId}/`)
      .then(({ data }) => {
        setExistingVisits(
          data.response[0].post_op_visits_array.map((p) => p.variety)
        );
      })
      .catch((err) => {
        setExistingVisits([]);
      });
  }, []);

  if (postOpId) {
    const variety = varietyOptions.find((v) => v.value === visitVariety)
      ? varietyOptions.find((v) => v.value === visitVariety).text
      : null;

    return (
      <div style={{ marginTop: "3em" }}>
        {variety && (
          <h2 style={{ marginBottom: "2em" }}>
            <b>{variety} Visit Clinical Findings</b>
          </h2>
        )}
        <ProcedureJoinManagement
          postOpId={postOpId}
          detailMode
          filters={[
            // procedureJoinKeys.complication,
            procedureJoinKeys.cataract_status,
            procedureJoinKeys.retinal_finding,
            procedureJoinKeys.sle_finding,
            procedureJoinKeys.ocular_comorbidites,
            procedureJoinKeys.systemic_comorbidites,
            // procedureJoinKeys.systemic_medications,
            procedureJoinKeys.ocular_medications,
            // procedureJoinKeys.gonioscopy,
          ]}
          selectedEye={eye}
        />
        <Button.Basic
          primary
          text="Finish"
          onClick={() => onSuccess(postOpId)}
        />
      </div>
    );
  }

  return (
    <div>
      {activeStep === STEP_POSTOP && (
        <React.Fragment>
          <PostOpForm
            onSuccess={(newPostOp, variety) => {
              // onSuccess(newPostOp.id);
              // setActiveStep(STEP_COMPLICATIONS);
              setPostOpId(newPostOp.id);
              setVisitVariety(variety);
              // setPostOp(newPostOp);
            }}
            postOpData={postOp}
            procedureDate={procedureDate}
            id={postOpId}
            existingVisits={existingVisits}
            procedureId={procedureId}
          />
        </React.Fragment>
      )}
    </div>
  );
}

PostOpCreate.defaultProps = {
  procedureDate: null,
};
